// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Orders_upper__xYMEj {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Orders_upper__xYMEj {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Orders_upper__xYMEj {
    grid-template-columns: 100%;
  }
}
.Orders_upper_container__Tibgx {
  box-sizing: border-box;
  padding: 2rem;
  width: 100%;
  background-color: var(--color-white);
  border-radius: 2rem;
}
.Orders_upper__metrics__OklQN {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Orders_upper__metrics__OklQN {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Orders_upper__metrics__OklQN {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Orders_upper__metrics__OklQN {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Orders_upper__metrics_processing__EADxT {
  background-color: var(--color-yellow);
}
.Orders_upper__metrics_shipped__\\+Pjmv {
  background-color: var(--color-primary);
  color: var(--color-white);
}
.Orders_upper__metrics_refund__rlWFa {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Orders_upper__metrics_completed__ZfiZo {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Orders_upper__metrics_void__z5Yha {
  background-color: var(--color-dark);
  color: var(--color-white);
}

.Orders_searchInMiddle__0PySO {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Orders_invoice__list__AAru4 {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Orders_invoice__beside__g3LqA {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Orders_invoice__checks__nsSJd {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 100%;
}
.Orders_invoice__checks_group__owrrZ {
  align-self: center;
  width: 100%;
}

.Orders_more__hMilv {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: red;
}

.Orders_view__e8e66 {
  position: relative;
}
.Orders_view_menu__3II6g {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 3rem;
  position: absolute;
  left: 20.5rem;
  top: 6rem;
}
.Orders_view_customerMenu__z8uHM {
  right: -20rem;
  top: 6rem;
}
.Orders_view_content__RdGRU {
  width: 35rem;
  margin-top: 3rem;
}

.Orders_sum__AXvtY {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
}

.Orders_line__c5ItX {
  border: 0.1px solid var(--color-grey);
  margin: 2rem 0;
}

.Orders_refunded__slZtz {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-error);
  color: var(--color-white);
  width: 9rem;
}

.Orders_processing__aIUx8 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  width: 9rem;
}

.Orders_void__FVFKt {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 9rem;
}

.Orders_shipped__4u21X {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  width: 9rem;
}

.Orders_delivered__uFn1h {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-green);
  color: var(--color-white);
  width: 9rem;
}

.Orders_st__Nbqwp {
  display: flex;
  justify-content: center;
}

.Orders_channelContainer__WiuHQ {
  position: relative;
}

.Orders_channel__vNlxi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Orders_exp__A4aY5 {
  background-color: var(--color-white);
}
.Orders_exp_text__ZjyyS {
  font-size: 1rem;
  font-weight: 700;
}

.Orders_icons__UQDQu {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.Orders_icons_img__FQcHM {
  display: grid;
  justify-content: right;
  align-items: center;
  width: 100%;
}
.Orders_icons_img__1__CBwRA {
  display: grid;
  justify-content: right;
  align-items: center;
  width: 100%;
  transform: rotateX(180deg);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Orders/Orders.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kCAAA;EACA,SAAA;AADD;AAGC;EALD;IAME,gCAAA;EAAA;AACF;AAEC;EATD;IAUE,2BAAA;EACA;AACF;AACC;EACC,sBAAA;EACA,aAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;AACF;AAGC;EACC,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AADF;AAGE;EARD;IASE,qCAAA;EAAD;AACF;AAEE;EAZD;IAaE,qCAAA;EACD;AACF;AACE;EAhBD;IAiBE,qCAAA;EAED;AACF;AAAE;EACC,qCAAA;AAEH;AACE;EACC,sCAAA;EACA,yBAAA;AACH;AAEE;EACC,oCAAA;EACA,yBAAA;AAAH;AAGE;EACC,oCAAA;EACA,yBAAA;AADH;AAIE;EACC,mCAAA;EACA,yBAAA;AAFH;;AAOA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;AAJD;;AAQC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AALF;AAQC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AANF;AASC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AAPF;AASE;EACC,kBAAA;EACA,WAAA;AAPH;;AAYA;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AATD;;AAYA;EACC,kBAAA;AATD;AAWC;EACC,2BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AATF;AAYC;EACC,aAAA;EACA,SAAA;AAVF;AAaC;EACC,YAAA;EACA,gBAAA;AAXF;;AAeA;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;AAZD;;AAeA;EACC,qCAAA;EACA,cAAA;AAZD;;AAeA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;AAZD;;AAeA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,wBAAA;EACA,WAAA;AAZD;;AAeA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;AAZD;;AAeA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,sCAAA;EACA,yBAAA;EACA,WAAA;AAZD;;AAeA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;AAZD;;AAeA;EACC,aAAA;EACA,uBAAA;AAZD;;AAeA;EACC,kBAAA;AAZD;;AAeA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAZD;;AAeA;EACC,oCAAA;AAZD;AAeC;EACC,eAAA;EACA,gBAAA;AAbF;;AAiBA;EACC,aAAA;EACA,uBAAA;EACA,eAAA;AAdD;AAgBC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAdF;AAgBE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;AAdH","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1.5fr;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 60rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t&_container {\n\t\tbox-sizing: border-box;\n\t\tpadding: 2rem;\n\t\twidth: 100%;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 2rem;\n\t}\n\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_processing {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_shipped {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_refund {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_completed {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_void {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n}\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n.invoice {\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tflex-wrap: wrap;\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\t\twidth: 100%;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n.more {\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: red;\n}\n\n.view {\n\tposition: relative;\n\n\t&_menu {\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\tfont-size: 3rem;\n\t\tposition: absolute;\n\t\tleft: 20.5rem;\n\t\ttop: 6rem;\n\t}\n\n\t&_customerMenu {\n\t\tright: -20rem;\n\t\ttop: 6rem;\n\t}\n\n\t&_content {\n\t\twidth: 35rem;\n\t\tmargin-top: 3rem;\n\t}\n}\n\n.sum {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tpadding: 8px 0;\n}\n\n.line {\n\tborder: 0.1px solid var(--color-grey);\n\tmargin: 2rem 0;\n}\n\n.refunded {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.processing {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\twidth: 9rem;\n}\n\n.void {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-dark);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.shipped {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-primary);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.delivered {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 5px 1rem;\n\tfont-size: 1rem;\n\tborder-radius: 0.5rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\twidth: 9rem;\n}\n\n.st {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.channelContainer {\n\tposition: relative;\n}\n\n.channel {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n}\n\n.exp {\n\tbackground-color: var(--color-white);\n\t// border: 1px solid var(--color-grey);\n\n\t&_text {\n\t\tfont-size: 1rem;\n\t\tfont-weight: 700;\n\t}\n}\n\n.icons {\n\tdisplay: flex;\n\tjustify-content: center;\n\tcursor: pointer;\n\n\t&_img {\n\t\tdisplay: grid;\n\t\tjustify-content: right;\n\t\talign-items: center;\n\t\twidth: 100%;\n\n\t\t&__1 {\n\t\t\tdisplay: grid;\n\t\t\tjustify-content: right;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\ttransform: rotateX(180deg);\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Orders_upper__xYMEj`,
	"upper_container": `Orders_upper_container__Tibgx`,
	"upper__metrics": `Orders_upper__metrics__OklQN`,
	"upper__metrics_processing": `Orders_upper__metrics_processing__EADxT`,
	"upper__metrics_shipped": `Orders_upper__metrics_shipped__+Pjmv`,
	"upper__metrics_refund": `Orders_upper__metrics_refund__rlWFa`,
	"upper__metrics_completed": `Orders_upper__metrics_completed__ZfiZo`,
	"upper__metrics_void": `Orders_upper__metrics_void__z5Yha`,
	"searchInMiddle": `Orders_searchInMiddle__0PySO`,
	"invoice__list": `Orders_invoice__list__AAru4`,
	"invoice__beside": `Orders_invoice__beside__g3LqA`,
	"invoice__checks": `Orders_invoice__checks__nsSJd`,
	"invoice__checks_group": `Orders_invoice__checks_group__owrrZ`,
	"more": `Orders_more__hMilv`,
	"view": `Orders_view__e8e66`,
	"view_menu": `Orders_view_menu__3II6g`,
	"view_customerMenu": `Orders_view_customerMenu__z8uHM`,
	"view_content": `Orders_view_content__RdGRU`,
	"sum": `Orders_sum__AXvtY`,
	"line": `Orders_line__c5ItX`,
	"refunded": `Orders_refunded__slZtz`,
	"processing": `Orders_processing__aIUx8`,
	"void": `Orders_void__FVFKt`,
	"shipped": `Orders_shipped__4u21X`,
	"delivered": `Orders_delivered__uFn1h`,
	"st": `Orders_st__Nbqwp`,
	"channelContainer": `Orders_channelContainer__WiuHQ`,
	"channel": `Orders_channel__vNlxi`,
	"exp": `Orders_exp__A4aY5`,
	"exp_text": `Orders_exp_text__ZjyyS`,
	"icons": `Orders_icons__UQDQu`,
	"icons_img": `Orders_icons_img__FQcHM`,
	"icons_img__1": `Orders_icons_img__1__CBwRA`
};
export default ___CSS_LOADER_EXPORT___;
